import { BrowserRouter, Routes, Route } from "react-router-dom";
import styled from "styled-components";

import HomePage from "./components/HomePage";
import UserLoginPage from "./components/UserLoginPage";
import ErrorPage from "./components/common/ErrorPage";
import { NotFoundError } from "services/errors";
import SubdomainHandler from "./SubdomainHandler";
import { useSubdomain } from "components/helper/SubdomainContext";
import Spinner from "components/common/Spinner";
import SessionPageGuard from "components/SessionPageGuard";

const Router = () => {
    const { IsSubdomainHandlingCompleted } = useSubdomain();
    return (
        <BrowserRouter>
            <SubdomainHandler>
                {IsSubdomainHandlingCompleted ? (
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route
                            path="login/:onlineCode"
                            element={<UserLoginPage />}
                        />
                        <Route
                            path="session/:onlineCode"
                            element={<SessionPageGuard />}
                        />
                        <Route
                            path="*"
                            element={<ErrorPage error={new NotFoundError()} />}
                        />
                    </Routes>
                ) : (
                    <SpinnerWrapper>
                        <Spinner />
                    </SpinnerWrapper>
                )}
            </SubdomainHandler>
        </BrowserRouter>
    );
};

const SpinnerWrapper = styled.div`
    margin-top: 10rem;
`;

export default Router;
